module.exports = __webpack_public_path__ + "assets/img/al12.630f47e4.jpg";